import { Text } from "@/components/Text";
import { Card, Skeleton } from "@/components/ui";
import { useFaucetStatus } from "@/hooks/api/useFaucet";
import { sanitizeNumber } from "@/lib/utils";
import { TokenBalances } from "./Statistics/TokenBalances";

export function FaucetStatistics() {
  const { data: status, isLoading } = useFaucetStatus();

  return (
    <Card>
      <Text variant="heading">Faucet Statistics</Text>
      <div className="flex flex-col gap-3">
        <div className="flex flex-wrap gap-3 items-center justify-center">
          <Card variant="secondary" className="flex-1">
            <Text variant="muted">Faucet Status</Text>
            <Skeleton isLoading={isLoading}>
              <Text
                variant="heading"
                data-active={status?.active}
                className="data-[active=true]:text-green-500 font-bold"
              >
                {status?.active ? "Active" : "Paused"}
              </Text>
            </Skeleton>
          </Card>
          <Card variant="secondary" className="flex-1">
            <Text variant="muted">Drips Today</Text>
            <Skeleton isLoading={isLoading}>
              <Text variant="heading" className="font-bold">
                {sanitizeNumber(status?.dripsToday.toString() ?? "0", 0)}
              </Text>
            </Skeleton>
          </Card>
        </div>
        <TokenBalances />
      </div>
    </Card>
  );
}
